import { SW_INIT, SW_UPDATE } from "../constants/pwa";
import { Action, PWAState } from "../models/pwa";

const initialState = {
  serviceWorkerInitialized: false,
  serviceWorkerUpdated: false,
  serviceWorkerRegistration: null,
};

function data(state: PWAState = initialState, action: Action): PWAState {
  switch (action.type) {
    case SW_INIT:
      return { ...state, serviceWorkerInitialized: true };
    case SW_UPDATE:
      return { ...state, serviceWorkerUpdated: true, serviceWorkerRegistration: action.payload };
    default:
      return state;
  }
}

export default data;
